import React from "react"
import { MainCP } from "../../Components/Atributos personales/MainCP"


const ViewAtributosPersonales: React.FC = () => <MainCP/>
 

export default ViewAtributosPersonales;


      


